export default __webpack_public_path__ + "static/media/Flyeasy-b.bc0adbad.png";